import { Component, OnInit,AfterViewInit } from '@angular/core';
import { CrudServiceService } from '../../../app/app-services/crud-service.service';
import { FeaturedProductsModel, CategoryList } from '../../shared/models/home.model';
import { HelperService } from '../../app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
declare var $: any;
declare const require: any;
var qs = require('qs');

@Component({ selector: 'app-home', templateUrl: './home.component.html', styleUrls: ['./home.component.scss'] })
export class HomeComponent implements OnInit,AfterViewInit {
	public featuredProductList: Array<FeaturedProductsModel> = [];
	public productList: Array<FeaturedProductsModel> = [];
	public snacksProductList: Array<FeaturedProductsModel> = [];
	public groceryProductList: Array<FeaturedProductsModel> = [];
  	public categoryList = [];
  	public brandList = [];
  	public bannerList = {};
  	public Image = "assets/img/deafultImg.png";
  	public featuredBrand = [];
  	public featuredBanner:any = {};
  	public productQuant: number = 1;
  	public categoryCollectionFirst:any = {};
  	public categoryCollectionSecond:any = {};

  	constructor(private router: Router, private crud: CrudServiceService, private toastr: ToastrService, private helpService: HelperService) {
    	this.getAllCategoryList();
    	this.getFeaturedProducts();
    	this.getBannerList();
    	this.getFeaturedBrand();
    	this.getBrandList();
    	this.getMerchantInfo();
		this.getCartList();		
  	}
	//cartList
	getCartList() {
		this.crud.getData("cart/list?customerId=" + localStorage.getItem("customerid")).subscribe((res: any) => {
			if (res.responseCode = "200") {

			}
		})
	}

	public redirectTocate(id) {    
        this.router.navigate(['/collectionByCategory/' + id]);
    }
    
	//marchantInfo
	getMerchantInfo() {
		this.crud.getData('merchant/config').subscribe((res) => {
			if (res.responseCode == 200) {
				//localStorage.setItem("taxValue", res.taxValue);
				localStorage.setItem("paymentGateWays", JSON.stringify(res.paymentGateWays))
				localStorage.setItem("currency", JSON.stringify(res.currency))
			}
		})
	}
	//get brand
	getBrandList() {
		this.crud.getData('brand/list').subscribe((res: any) => {
			if (res.responseCode == 200) {
				this.brandList = res.brands
			}
		// console.log("brand", res)
		})
	}

  	//get featured brand 
  	getFeaturedBrand() {
    	this.crud.getData("banner/featured").subscribe((res: any) => {
            if (res.responseCode = 200) {
                this.featuredBanner = res.banners[0];                
            }
        },error => {
            this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
        });

        this.crud.getData('brand/featured').subscribe((res:any) => {
            if(res.responseCode = 200){
                this.featuredBrand = res.brands;
            }
        },error=>{
            this.toastr.error("Something went wrong",'Error',{timeOut:3000});
        });
	  }
	  
	//get banner List
	getBannerList() {
		this.crud.getData("banner/sliders").subscribe((res: any) => {
			if (res.responseCode = 200) {
				this.bannerList = res.sliders;
				// console.log("bannerList", this.bannerList[0])
			}
		}, error => {
			this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
		})
	}

	//get categoryList
	getAllCategoryList() {
		this.crud.getData("category/featured").subscribe((res: any) => {
			if (res.responseCode = 200) {
				this.categoryList = res.categories;
				this.categoryList.forEach((element, i) => {
                    this.crud.getData("category/subcategory/list?categoryId=" + element.catId).subscribe((res) => {
                        if (res.responseCode == 200) {
                            this.categoryList[i].subCategories = res.subcategories;
                        }
                    })

                })
			}
		}, error => {
			this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
		})
	}

	//get fetured Products
	getFeaturedProducts() {
		this.crud.getData("product/featured").subscribe((res: any) => {
			if (res.responseCode == 200) {
				this.productList =  res.products;
				this.featuredProductList = this.chunk(res.products,2);
				//console.log("Featured PRoduct",this.featuredProductList);			
			}
		}, error => {
			this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
		})
	}

	showProducts(id) {
		let body = {
			catId: id,
			subCatId: null
		}
		this.helpService.subCat.next(body);
		this.router.navigate(['/collectionByCategory/' + id])
	}

	ngOnInit() {
		this.helpService.cartNumber.subscribe((numb: any) => {
			// console.log("from home", numb)
		})
	}

	collectionPage(data) {
		this.router.navigate(['/catId/' + data.categoryId + '/product-detalil/' + data.prdcode])
	}	

	public productDetails(id, catId) {        
        this.router.navigate(['/catId/' + catId + '/product-detalil/' + id])
    }

	ngAfterViewInit() {
		setTimeout(function(){
            $(document).ready(function(){
				if ( $('#main_slider').length ){
		            $("#main_slider").revolution({
		                sliderType:"standard",
		                sliderLayout:"auto",
		                delay:5000,
		                disableProgressBar:"on",
		                navigation: {
		                    onHoverStop: 'off',
		                    touch:{
		                        touchenabled:"on"
		                    },
		                    arrows: {
		                        style:"normal",
		                        enable:false,
		                        hide_onmobile:true,
		                        hide_under:820,
		                        hide_onleave:true,
		                        hide_delay:200,
		                        hide_delay_mobile:1200,
		                        left: {
		                            h_align: "left",
		                            v_align: "center",
		                            h_offset: 5,
		                            v_offset: 0
		                        },
		                        right: {
		                            h_align: "right",
		                            v_align: "center",
		                            h_offset: 5,
		                            v_offset: 0
		                        }
		                    },
		                },
		                responsiveLevels:[4096,1199,992,767,480],
		                gridwidth:[1170,1000,750,700,300],
		                gridheight:[400,400,400,400,400],
		                lazyType:"smart",
		                fallbacks: {
		                    simplifyAll:"off",
		                    nextSlideOnWindowFocus:"off",
		                    disableFocusListener:false,
		                }
		            })
		        }
		    });    
		    if ( $('.l_product_slider').length ){
	            $('.l_product_slider').owlCarousel({
	                loop:true,
	                margin: 30,
	                items: 4,
	                nav:true,
	                autoplay: true,
	                smartSpeed: 1500,
	                dots:false,
	                navContainerClass: 'l_product_slider',
	                navText: ['<i class="arrow_carrot-left" aria-hidden="true"></i>','<i class="arrow_carrot-right" aria-hidden="true"></i>'],
	                responsiveClass: true,
	                responsive: {
	                    0: {
	                        items: 1,
	                    },
	                    575: {
	                        items: 2,
	                    },
	                    992: {
	                        items: 3,
	                    },
	                    1200: {
	                        items: 4,
	                    }
	                }
	            })
	        }
        },3000); 
	}	

	chunk(array, size) {
	  	const chunked_arr = [];
	  	let copied = [...array]; // ES6 destructuring
	  	const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
	  	for (let i = 0; i < numOfChild; i++) {
	    	chunked_arr.push(copied.splice(0, size));
	  	}
	  	return chunked_arr;
	}


	addToCart(code,$event) {

		var el = $($event.target).parents('.l_p_text').prev().find(".variation-option-size").children('select').val();
        var options = this.getColorAndSizeByVariation(el,code); 
		
		// console.log(localStorage.getItem("customerid"))
		if (localStorage.getItem("customerid") == undefined || localStorage.getItem("customerid") == null) {
			this.toastr.warning("Please login first", "Login is Required", { timeOut: 3000 })
		} else {
			fetch(this.crud.getEndPoint("cart/add"),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': 'Basic c2hvcHB5OjExODk0MDY0'
				},
				body: qs.stringify({
					email: localStorage.getItem("email"),
					customerId: localStorage.getItem("customerid"),
					productId: code,
					variationId:el,
					color:options.color,
					size:options.size,
					quantity: this.productQuant
				})
			}).then(response => response.json())
			.then(response => {
				if (response.responseCode == "200") {
					// console.log("added", response)
					this.toastr.success(response.responseMessage, response.description, { timeOut: 3000 });
					this.router.navigate(['/cart-page'])
				}
                                 else{
                   this.toastr.error(response.responseMessage, response.description, { timeOut: 3000 });
                }
			}).catch(error => console.error('Error:', error))
		}
	}

	onSizeAndColorChange(variationId:string,prdcode:string,$event): void 
    {
       var options = this.getColorAndSizeByVariation(variationId,prdcode);                    
      
        //$($event.target).parent().siblings().find('select').val(variationId).change();      
    }

    getColorAndSizeByVariation(variationId,prdcode)
    {
        let color,size = null;

        const products:FeaturedProductsModel[] =  this.productList.filter((product) => {
            return product.prdcode == prdcode;
        });

        const product = products.length? products[0]: null;  
        for(let i = 0; i < product.variations.length; i++){
            if(product.variations[i].id == variationId){
                color = product.variations[i].color;
                size = product.variations[i].size;
            }           
        }    

        return {color,size};
    }
}
